export { useWindowMessageListen } from './hook';
export type { Hook, Props, Result } from './types';
